module.exports = __webpack_public_path__ + "img/00.2b9a7cda.png";